import RCTooltip from 'rc-tooltip'
import './tooltip.css'

export const Tooltip = RCTooltip

export default Tooltip
